export enum RouteName {
  ABOUT = 'About',
  ANALYTICS = 'Analytics',
  NEWS = 'News',
  INSIGHTS = 'Insights',
  BROCHURE_DOWNLOAD = 'Brochure Download',
  RISK_FACTOR_DOWNLOAD = 'Risk Factor Download',
  DATA = 'Data',
  DATA_V3 = 'Data V3',
  EQUITY_SCREENER = 'Equity Screener',
  PRINCIPAL_COMPONENT_ANALYSIS = 'Principal Component Analysis',

  CONSTITUENT_RISK = 'Constituent Risk',
  CONSTITUENT_RISK_PORTFOLIO_DEPRECATED = 'Constituent Risk Portfolio DEPRECATED ROUTE',
  CONSTITUENT_RISK_STRATEGY_DEPRECATED = 'Constituent Risk Strategy DEPRECATED ROUTE',

  POSITION = 'Position',
  POSITION_STRATEGY_DEPRECATED = 'Position Strategy DEPRECATED ROUTE',
  POSITION_PORTFOLIO_DEPRECATED = 'Position Portfolio DEPRECATED ROUTE',

  DROP_ZONE = 'Drop Zone',
  KNOWLEDGE_BASE = 'Knowledge Base',
  FOLDER = 'Portfolio Selection',
  HOME = 'Home',
  MORNINGSTAR = 'Morningstar',
  QIS_REQUESTS = 'QIS Requests',
  MY_LAB = 'My Lab',
  MY_LAB_PROXY_TABLE = 'ProxyTable',
  TRADE_REPOSITORY = 'Trade Repository',
  NOT_FOUND = 'Not Found',

  PERFORMANCE = 'Performance',
  STRATEGY_PERFORMANCE_CONTRIBUTION = 'Performance Contribution - Contribution',
  STRATEGY_PERFORMANCE_RECONCILIATION = 'Performance Contribution - Reconciliation',

  PORTFOLIO_CONSTRUCTION = 'Portfolio Construction',
  PC_PERFORMANCE = 'Performance - Portfolio Construction',
  PC_EFFICIENT_FRONTIER = 'Efficient Frontier - Portfolio Construction',
  PC_CONTRIBUTIONS = 'Contributions - Portfolio Construction',
  PC_ROLLING = 'Rolling Metric - Portfolio Construction',
  PC_CORRELATION = 'Correlation - Portfolio Construction',
  PC_RECONCILIATION = 'Reconciliation - Portfolio Construction',
  PC_COMPOSITION = 'Factor Composition - Portfolio Construction',

  FACTOR_DECOMPOSITION = 'Factor Decomposition',
  FD_REGRESSION_TABLE = 'Regression Table - Factor Decomposition',
  FD_ROLLING = 'Rolling - Factor Decomposition',
  FD_FACTOR_COMPARISON = 'Factor Comparison - Factor Decomposition',

  PRIVACY_POLICY = 'Privacy Policy',
  RESOURCES = 'Resources',
  RESOURCES_API_CLIENT = 'API Documentation',
  RESOURCES_API_PREMIALAB = 'API (Dev)',
  RESOURCES_MLAPP_PREMIALAB = 'MLAPP (Dev)',
  RESOURCES_AQ_PREMIALAB = 'AQ (Dev)',
  RESOURCES_FILE_DOWNLOADS = 'PlbPy',
  RESOURCES_RISK_REPORT_DOWNLOADS = 'Risk Report Downloads',

  // INSIGHTS
  INSIGHTS_RESEARCH = 'Research',
  INSIGHTS_PURE_FACTORS = 'Pure Factor Monthly Report',
  INSIGHTS_WHITEPAPER = 'Whitepaper',

  FACTSHEET = 'Factsheet',
  TERMS = 'Terms',
  UNAUTHORIZED = 'Unauthorised',
  LOGIN = 'Login',
  LOGOUT = 'Logout',

  // ARTICLES
  ARTICLES = 'Articles',
  ARTICLES_LIST = 'List - Articles',
  ARTICLES_READ_ARTICLE = 'Read Article - Articles',
  ARTICLES_EDIT_ARTICLE = 'Edit Article - Articles',

  // parent route for all sandboxes
  SANDBOX = 'Sandbox',
  SANDBOX_NAVIGATION_PANEL_V2 = 'Sandbox - Navigation Panel v2',
  SANDBOX_DESIGN = 'Sandbox - Design',

  // ADMIN CONSOLE
  ADMIN_CONSOLE = 'Admin Console',

  ADMIN_CONSOLE_TEAMS_MANAGEMENT = 'Team Management',
  ADMIN_CONSOLE_TEAMS_MANAGEMENT_VIEW_TEAMS = 'View Teams - Team Management - Admin Console',
  ADMIN_CONSOLE_TEAMS_MANAGEMENT_EDIT_TEAM = 'Edit Team - Teams Management - Admin Console',

  ADMIN_CONSOLE_USER_MANAGEMENT = 'User Management',
  ADMIN_CONSOLE_USER_MANAGEMENT_LIST = 'All Users - User Management - Admin Console',
  ADMIN_CONSOLE_USER_MANAGEMENT_EDIT_USER = 'Edit User - User Management - Admin Console',
  ADMIN_CONSOLE_USER_MANAGEMENT_SESSIONS = 'Sessions - User Management - Admin Console',

  ADMIN_CONSOLE_API_KEYS = 'API Keys',

  ADMIN_CONSOLE_CLIENT_REQUESTS = 'Client Requests',
  ADMIN_CONSOLE_CLIENT_REQUESTS_LIST = 'List - Client Requests - Admin Console',
  ADMIN_CONSOLE_CLIENT_REQUESTS_EDIT = 'Edit Client Request - Client Requests - Admin Console',

  ADMIN_CONSOLE_PLATFORM_HEALTH = 'Platform Health',

  ADMIN_CONSOLE_BASKET_REQUEST = 'Basket Request',

  ADMIN_CONSOLE_TRACK_MANAGEMENT = 'Track Management',
  ADMIN_CONSOLE_TRACK_MANAGEMENT_STRATEGIES = 'Strategies - Track Management',
  ADMIN_CONSOLE_TRACK_MANAGEMENT_STRATEGIES_CREATE = 'Add Strategy',
  ADMIN_CONSOLE_TRACK_MANAGEMENT_STRATEGIES_EDIT = 'Edit Strategy',
  ADMIN_CONSOLE_TRACK_MANAGEMENT_STRATEGIES_TRACK_SYNC_JOBS = 'Track Sync Jobs',
  ADMIN_CONSOLE_TRACK_MANAGEMENT_STRATEGIES_TSE_PROVIDERS = 'Providers',
  ADMIN_CONSOLE_TRACK_MANAGEMENT_DATABASE = 'Database - Track Management - Admin Console',
  ADMIN_CONSOLE_TRACK_MANAGEMENT_USER_TRACKS = 'User Tracks - Admin Console',
  ADMIN_CONSOLE_TRACK_MANAGEMENT_USER_TRACKS_VIEW = 'View User Track',

  ADMIN_CONSOLE_FILE_MANAGEMENT = 'File Management',
  ADMIN_CONSOLE_FILE_MANAGEMENT_LIST = 'List - File Management',
  ADMIN_CONSOLE_FILE_MANAGEMENT_VIEW_FILE = 'View File',
  ADMIN_CONSOLE_FILE_MANAGEMENT_VIEW_PARSING_REPORT = 'View Parsing Report',

  ADMIN_CONSOLE_INSTRUMENTS_MANAGEMENT = 'Instruments Management',
  ADMIN_CONSOLE_INSTRUMENTS_MANAGEMENT_METRICS = 'Metrics',
  ADMIN_CONSOLE_INSTRUMENTS_MANAGEMENT_FUTURES = 'Futures',
  ADMIN_CONSOLE_INSTRUMENTS_MANAGEMENT_VIEW_FUTURE = 'View Future',
  ADMIN_CONSOLE_INSTRUMENTS_MANAGEMENT_STOCKS = 'Stocks',
  ADMIN_CONSOLE_INSTRUMENTS_MANAGEMENT_BONDS = 'Bonds',
  ADMIN_CONSOLE_INSTRUMENTS_MANAGEMENT_FUNDS = 'Funds',
  ADMIN_CONSOLE_INSTRUMENTS_MANAGEMENT_ETFS = 'ETFs',
  ADMIN_CONSOLE_INSTRUMENTS_MANAGEMENT_INDICES = 'Indices',
  ADMIN_CONSOLE_INSTRUMENTS_MANAGEMENT_MARKET_INDICES = 'Market Indices',
  ADMIN_CONSOLE_INSTRUMENTS_MANAGEMENT_CDS_INDICES = 'CDS Indices',
  ADMIN_CONSOLE_INSTRUMENTS_MANAGEMENT_VIEW_CDS_INDEX = 'View CDS Index',
  ADMIN_CONSOLE_INSTRUMENTS_MANAGEMENT_CUSTOM_INDICES = 'Custom Indices',
  ADMIN_CONSOLE_INSTRUMENTS_MANAGEMENT_VIEW_CUSTOM_INDEX = 'View Custom Index',
  ADMIN_CONSOLE_INSTRUMENTS_MANAGEMENT_VIEW_INSTRUMENT = 'View Instrument',
  ADMIN_CONSOLE_INSTRUMENTS_MANAGEMENT_VIEW_INSTRUMENT_POSITION = 'View Instrument - Position',
  ADMIN_CONSOLE_INSTRUMENTS_MANAGEMENT_VIEW_INSTRUMENT_RISK = 'View Instrument - Risk',
  ADMIN_CONSOLE_INSTRUMENTS_MANAGEMENT_VIEW_INSTRUMENT_OPTIONS = 'View Instrument - Options',
  ADMIN_CONSOLE_INSTRUMENTS_MANAGEMENT_VIEW_INSTRUMENT_FORWARDS = 'View Instrument - Forwards',
  ADMIN_CONSOLE_INSTRUMENTS_MANAGEMENT_VIEW_INSTRUMENT_SWAPS = 'View Instrument - Swaps',
  ADMIN_CONSOLE_INSTRUMENTS_MANAGEMENT_VIEW_INSTRUMENT_PARSING_LOG = 'View Instrument - Parsing Log',

  ADMIN_CONSOLE_CONSTITUENT_MANAGEMENT = 'Constituent Management',
  ADMIN_CONSOLE_CONSTITUENT_MANAGEMENT_SEARCH = 'Search - Constituent Management',
  ADMIN_CONSOLE_CONSTITUENT_MANAGEMENT_PROXY_CHECK = 'Proxy Check',
  ADMIN_CONSOLE_CONSTITUENT_MANAGEMENT_VIEW_CONSTITUENT = 'View Constituent',
  ADMIN_CONSOLE_CONSTITUENT_MANAGEMENT_VIEW_CONSTITUENT_FILES = 'View Files',
  ADMIN_CONSOLE_CONSTITUENT_MANAGEMENT_VIEW_CONSTITUENT_INTRADAY_FILES = 'View Intraday Files',
  ADMIN_CONSOLE_CONSTITUENT_MANAGEMENT_VIEW_CONSTITUENT_POSSIBLE_POSITIONS = 'View Positions',
  ADMIN_CONSOLE_CONSTITUENT_MANAGEMENT_VIEW_CONSTITUENT_INDIVIDUAL_POSITION = 'View Position',

  ADMIN_CONSOLE_CONTENT_MANAGEMENT = 'Content Management',

  ADMIN_CONSOLE_REPORT_FIELDS = 'Report Fields',
  ADMIN_CONSOLE_REPORT_FIELDS_VIEW = 'View Report Field',

  ADMIN_CONSOLE_PERFORMANCE_CONTRIBUTION = 'Performance Contribution - Admin Console',
  ADMIN_CONSOLE_PERFORMANCE_CONTRIBUTION_CONFIG = 'Performance Contribution (Config)',
  ADMIN_CONSOLE_PERFORMANCE_CONTRIBUTION_CONFIG_CREATE = 'Create Performance Contribution Config',
  ADMIN_CONSOLE_PERFORMANCE_CONTRIBUTION_CONFIG_EDIT = 'Edit Performance Contribution',
  ADMIN_CONSOLE_PERFORMANCE_CONTRIBUTION_BACKFILL = 'Performance Contribution (Backfill)',
  ADMIN_CONSOLE_PERFORMANCE_CONTRIBUTION_GENERATED_DATA = 'Performance Contribution (Generated Data)',
  ADMIN_CONSOLE_PERFORMANCE_CONTRIBUTION_INDEX_DATES = 'Performance Contribution Index Dates',
  ADMIN_CONSOLE_PERFORMANCE_CONTRIBUTION_INDEX_DATA = 'Performance Contribution Index Data',
  ADMIN_CONSOLE_PERFORMANCE_CONTRIBUTION_JOB_STATUS = 'Performance Contribution (Job Status)',

  ADMIN_CONSOLE_RISK_MANAGEMENT = 'Risk Management',
  ADMIN_CONSOLE_RISK_MANAGEMENT_RISK_PORTFOLIOS = 'Risk Portfolios',
  ADMIN_CONSOLE_RISK_MANAGEMENT_RISK_KPI = 'Risk KPI',
  ADMIN_CONSOLE_RISK_MANAGEMENT_RISK_VALIDATION = 'Risk Validation',

  ADMIN_CONSOLE_CUSTOM_REPORT = 'Custom Report',
  ADMIN_CONSOLE_CUSTOM_REPORT_JOB_STATUS = 'Custom Report Job Status',
  ADMIN_CONSOLE_CUSTOM_REPORT_RISK_EXCEL_JOB_STATUS = 'Custom Report Risk Excel Job Status',

  ADMIN_CONSOLE_QA = 'QA',
  ADMIN_CONSOLE_QA_TRACKS = 'Track QA',
  ADMIN_CONSOLE_QA_TRACK_VIEW = 'View Track QA',
  ADMIN_CONSOLE_QA_CONSTITUENT = 'Constituent QA',
  ADMIN_CONSOLE_QA_CONSTITUENT_VIEW = 'View Constituent QA',
  ADMIN_CONSOLE_QA_INTRADAY = 'Intraday QA',
  ADMIN_CONSOLE_QA_INTRADAY_VIEW = 'View Intraday QA',
  ADMIN_CONSOLE_QA_STATIC = 'Static QA',
  ADMIN_CONSOLE_QA_STATIC_VIEW = 'View Static QA',
  ADMIN_CONSOLE_QA_BARRA_FACTOR = 'Barra Factor QA',
  ADMIN_CONSOLE_QA_BARRA_FACTOR_VIEW = 'View Barra Factor QA',

  ADMIN_CONSOLE_SUBSCRIPTIONS = 'Subscriptions',

  ADMIN_CONSOLE_EXCEL_JOBS = 'Excel Jobs',

  ADMIN_CONSOLE_PLATFORM_ANALYTICS = 'Platform Analytics',

  ADMIN_CONSOLE_MIGRATIONS = 'Migrations',
  ADMIN_CONSOLE_MIGRATIONS_INSPECT = 'Inspect Migration',

  ADMIN_CONSOLE_MUTATIONS = 'Mutations',
  ADMIN_CONSOLE_MUTATIONS_INSPECT = 'Inspect Mutation',

  ADMIN_CONSOLE_SETTINGS = 'Settings',

  ADMIN_CONSOLE_PDF_MANAGEMENT = 'PDF Management',

  /**
   * Can be removed??? Or only in use in HSBC
   */
  SEO_MANAGEMENT_ADMIN = 'SEO Management',

  // User Setting

  USER_SETTINGS = 'User Settings',

  BASKET = 'Basket',

  UNIVERSE = 'Universe',

  AI_REPORT = 'AI Report',

  PDF_HOME = 'PDF Home',
  FACTSHEET_PDF = 'Factsheet PDF',
  PORTFOLIO_COMBINED_MODULE_PDF = 'Combined Module PDF Portfolio',
  STRATEGY_COMBINED_MODULE_PDF = 'Combined Module PDF Strategy',
  PRINCIPAL_COMPONENT_ANALYSIS_PDF = 'Principal Component Analysis PDF',
  FACTOR_DECOMPOSITION_PDF = 'Factor Decomposition PDF',
  CONSTITUENT_RISK_PDF = 'Constituent Risk PDF',
  POSITION_PDF = 'Position PDF',
  STRATEGY_PERFORMANCE_CONTRIBUTION_PDF = 'Performance Contribution PDF',

  // DEPRECATED ROUTES
  CONSTITUENT_RISK_DEPRECATED = 'Constituent Risk DEPRECATED ROUTE',
  FACTOR_DECOMPOSITION_NEW_DEPRECATED = 'DEPRECATED New Factor Decomposition URL',
  FACTOR_DECOMPOSITION_PORTFOLIO_DEPRECATED = 'DEPRECATED Portfolio Factor Decomposition URL',
  FACTOR_DECOMPOSITION_STRATEGY_DEPRECATED = 'DEPRECATED Strategy Factor Decomposition URL',
  FACTOR_DECOMPOSITION_V3_DEPRECATED = 'DEPRECATED Factor Decomposition v3 URL',

  /** Used to identify the Performance Contribution PDF */
  PERFORMANCE_CONTRIBUTION_TOOL = 'Performance Contribution',
}
